<div id="pre-bootstrap-container">
  <div id="pre-bootstrap">
    <div class="messaging">
      {{message}}
    </div>
  </div>
</div>
